import {twMerge} from 'tailwind-merge';

export interface HorizontalDividerProps {
  className?: string;
}

export function HorizontalDivider({className}: HorizontalDividerProps) {
  return <hr className={twMerge(`bg-black h-px w-full my-16`, className)} />;
}
